import {
    Company,
} from 'app/Apps/ContactManagement/Companies/Companies.types'
import {
    Country,
    State,
} from 'app/Apps/ContactManagement/Countries/Countries.types'
import {
    Currency,
    LocationType,
    AddressCategory,
    RegionZeroLevel,
    RegionFirstLevel,
    RegionSecondLevel,
    StorageType,
    StorageSpaceRatio,
    AddressMainCategory,
    ServiceCenterStatus,
} from 'app/enums/label.enums'
import {
    RolesTypes,
} from 'app/utils/hasPermission'

export type Storage = {
    id?: number,
    storageType?: StorageType,
    preconTimeInHours?: number,
    immediateUseOnly?: boolean,
    preconEndOnWorkdayOnly?: boolean,
    storageSpaceRatio?: StorageSpaceRatio,
    preconCapacity?: number,
    inStoragePrecon?: boolean,
    changedOn?: string,
    changedBy?: string,
}

export type ServiceCenterMetrics = {
    currency?: Currency,
    dryIceCapacity?: number,
    fixedCosts?: number,
    id?: number,
    operationalDays?: string,
    paymentSchedule?: string,
    pcmCapacity?: number,
    storages?: Storage[],
    variableCosts?: number,
    workforce?: number,
}

export type Location = {
    locationType?: LocationType,
    latitude?: number,
    longitude?: number,
    city?: string,
    addressMainCategory?: AddressMainCategory[],
    enhancedSkyCenterScanning?: boolean,
    addressCategory?: AddressCategory[],
    addressLine1?: string,
    addressLine2?: string,
    addressLine3?: string,
    area?: string,
    attachments?: any[],
    attachmentsIds?: any[],
    changedBy?: string,
    company?: Company,
    companyId?: number,
    country?: Country,
    countryName?: string,
    countryId?: number,
    createdBy?: string,
    createdOn?: string,
    currentPlaceId?: string,
    deleted?: boolean,
    iataCode?: string,
    id?: number,
    isApprovedSubContractor?: boolean,
    isMainAddress?: boolean,
    isProspect?: boolean,
    isShippingLocation?: boolean,
    locationName?: string,
    locationNumber?: string,
    requiresTruckDetails?: boolean,
    serviceCenterMetrics?: ServiceCenterMetrics,
    serviceCenterPlannedStartDate?: string,
    serviceCenterStatus?: ServiceCenterStatus,
    state?: State,
    stateId?: number,
    timeZone?: string,
    unloCode?: string,
    zip?: string
    archived?: boolean,
    region?: RegionFirstLevel,
    aebServiceProviderId?: string,
    portOfReference?: Location,
    regionZeroLevel?: RegionZeroLevel,
    regionFirstLevel?: RegionFirstLevel,
    regionSecondLevel?: RegionSecondLevel,
    freightRateServiceProviderCode?: string,
    skyMindId?: number,
}

export const ROLES_PROSPECT_ALLOWED: RolesTypes[] = [
    'location_sales',
    'location_cs',
    'location_cs_super',
]

export const ROLES_NOPROSPECT_AND_PROSPECT_ALLOWED: RolesTypes[] = [
    'location_cs',
    'location_cs_super',
]
